import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 20px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #343434;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 10px;
  border-radius: 4px;
  min-width: 300px;

  text-transform: capitalize;
  font-size: 18px;
  cursor: pointer;

  & > span {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
    color: #000;
  }

  &:not(:first-of-type) {
    margin-top: 5px;
  }
`;
